export interface ReportToolbar {
  report: string;
}
